import { videoIdentificationApi } from 'api';
import { ViPartnerInfo } from 'pco-product-service-internal-consumer';

export const getVideoIdentificationData = async (partnerNumber: string): Promise<ViPartnerInfo> => {
  return await videoIdentificationApi.getPartnerInfoForVideoIdent({ partnerUid: partnerNumber });
};
